import { combineLatest, Observable, ObservableInputTuple, of, MonoTypeOperatorFunction } from 'rxjs';
import { Injector, afterNextRender, inject } from '@angular/core';
import { switchMap } from 'rxjs/operators';

export function combineLatestEmptySafe<A extends readonly unknown[]>(sources: readonly [...ObservableInputTuple<A>]): Observable<A> {
	if (sources.length === 0) return of(<A>(<unknown>[]));
	return combineLatest(sources);
}

/**
 * Een RxJS operator die wacht tot Angular klaar is met renderen voordat de waarde wordt doorgegeven.
 * @param injector Verplicht als je deze operator buiten een constructor gebruikt.
 */
export function delayUntilNextRender<T>(injector?: Injector): MonoTypeOperatorFunction<T> {
	const localInjector = injector ?? inject(Injector);

	return (source: Observable<T>) =>
		source.pipe(
			switchMap(
				(value) =>
					new Observable<T>((subscriber) => {
						afterNextRender(
							() => {
								subscriber.next(value);
								subscriber.complete();
							},
							{ injector: localInjector }
						);
					})
			)
		);
}
